import React, { useState, useEffect, Fragment } from 'react'
import { useDispatch } from 'react-redux'
import { formatComma } from '../../helpers/helpers'
import { Form, Card, Nav, Table, Badge, Tab } from 'react-bootstrap'
import callApi from '../../helpers/callapi'
import { format } from 'date-fns'
import ModalOrderDetail from './ModalOrderDetail'
import Pagination from '../../components/Nav/Pagination'

const Transfer = () => {
  const [orders, setTransfers] = useState([])
  const [currentPage, setCurrentPage] = useState(1)
  const [selectedOrder, setSelectedOrder] = useState({})
  const [showModalOrderDetail, setShowModalOrderDetail] = useState(false)
  const [findingAmount, setFindingAmount] = useState(0)
  const [findingDate, setFindingDate] = useState('')
  const [findingTime, setFindingTime] = useState('')
  const dispatch = useDispatch()

  const fetchTransfers = async (page) => {
    try {
      dispatch({ type: 'loading_show' })
      const query = { page: page || 1 }
      if (findingAmount && findingDate && findingTime) {
        query.id =
          findingDate
            .split('-')
            .map((x) => ('0' + x).slice(-2))
            .join('-') +
          '-' +
          findingTime
            .split(':')
            .map((x) => ('00' + x).slice(-2))
            .join('-')
        query.amount = findingAmount
        query.page = 1
      }
      const { results: orders } = await callApi({
        url: '/transfers',
        query,
      })
      setTransfers(orders)
      dispatch({ type: 'loading_hide' })
    } catch (error) {
      setTransfers([])
      dispatch({ type: 'loading_hide' })
    }
  }

  const searchTransfers = async (page) => {
    try {
      dispatch({ type: 'loading_show' })
      const query = { page: page || 1 }
      if (findingAmount && findingDate && findingTime) {
        query.id =
          findingDate
            .split('-')
            .map((x) => ('0' + x).slice(-2))
            .join('-') +
          '-' +
          findingTime
            .split(':')
            .map((x) => ('00' + x).slice(-2))
            .join('-')
        query.amount = findingAmount
        query.page = 1
      } else if (!findingDate) {
        alert('กรุณากรอก วัน-เดือน-ปี เช่น 22-03-2021')
        dispatch({ type: 'loading_hide' })
        return
      } else if (!findingTime) {
        alert('กรุณากรอกเวลา เช่น 00:00')
        dispatch({ type: 'loading_hide' })
        return
      } else if (!findingAmount) {
        alert('กรุณากรอกจำนวนเงิน')
        dispatch({ type: 'loading_hide' })
        return
      }
      const { results: orders } = await callApi({
        url: '/transfers',
        query,
      })
      setTransfers(orders)
      dispatch({ type: 'loading_hide' })
    } catch (error) {
      setTransfers([])
      dispatch({ type: 'loading_hide' })
    }
  }

  const fetchOrderDetail = async (orderId) => {
    const _order = await callApi({ url: `/orders/${orderId}` })
    setSelectedOrder(_order)
  }

  useEffect(() => {
    fetchTransfers()
  }, [])

  const onChangePage = (page) => {
    setCurrentPage(page)
    fetchTransfers(page)
  }

  const displayTabStatus = () => {
    const _TabData = [
      { title: 'ทั้งหมด', value: 'all' },
      { title: 'ที่แจ้งแล้ว', value: 'matched' },
      { title: 'ยังไม่แจ้ง', value: 'notMatched' },
    ]

    return (
      <Tab.Container defaultActiveKey={_TabData[0].value}>
        <Nav as="ul" className="nav-pills mb-4 light">
          {_TabData.map((data, i) => {
            return (
              i !== _TabData.length && (
                <Nav.Item as="li" key={i}>
                  <Nav.Link
                    eventKey={data.value}
                    onClick={async () => {
                      fetchTransfers(1, undefined, data.value)
                    }}
                  >
                    {data.title}
                  </Nav.Link>
                </Nav.Item>
              )
            )
          })}
        </Nav>
      </Tab.Container>
    )
  }

  const displayInputDateTime = () => {
    return (
      <div className="d-flex justify-content-center mb-4">
        <Form.Control
          type="text"
          defaultValue={findingDate}
          placeholder="วัน-เดือน-ปี"
          onChange={(e) => setFindingDate(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              searchTransfers()
            }
          }}
        />
        <Form.Control
          type="text"
          defaultValue={findingTime}
          placeholder="เวลา 00:00"
          onChange={(e) => setFindingTime(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              searchTransfers()
            }
          }}
        />
        <Form.Control
          type="text"
          defaultValue={findingAmount || ''}
          placeholder="จำนวนเงิน"
          onChange={(e) => setFindingAmount(e.target.value)}
          onKeyPress={(e) => {
            if (e.key === 'Enter') {
              searchTransfers()
            }
          }}
        />
      </div>
    )
  }

  const displayTableTransection = () => {
    const _HeadTable = ['วันที่โอน', 'ช่องทาง', 'จำนวนเงิน', 'ประเภทรายการ', 'เลขที่บัญชี', 'รายละเอียด', 'คำสั่งซื้อ']

    return (
      <Table responsive striped bordered className="verticle-middle">
        <thead>
          <tr>
            {_HeadTable.map((head, i) => {
              return <td key={i}>{head}</td>
            })}
          </tr>
        </thead>
        <tbody>
          {orders.map((order, i) => {
            return (
              <tr key={i}>
                <td>{format(new Date(order.date), 'dd-MM-yyyy HH:mm:ss')}</td>
                <td>{order.channel}</td>
                <td>{order.amount}</td>
                <td>{formatComma(order.fee)}</td>
                <td>{order.bankAccount}</td>
                <td>{order.detail}</td>
                <td>
                  {order.isMatched && (
                    <Badge
                      variant="primary light"
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        setShowModalOrderDetail(true)
                        fetchOrderDetail(order.order)
                      }}
                    >
                      ดูคำสั่งซื้อ
                    </Badge>
                  )}
                </td>
              </tr>
            )
          })}
        </tbody>
      </Table>
    )
  }

  return (
    <Fragment>
      <Card>
        <Card.Header>
          <Card.Title>Transection</Card.Title>
        </Card.Header>
        <Card.Body>
          {displayTabStatus()}
          {displayInputDateTime()}
          {displayTableTransection()}
          <Pagination
            currentPage={currentPage}
            onPrevPage={() => onChangePage(currentPage - 1)}
            onNextPage={() => onChangePage(currentPage + 1)}
            items={orders}
            perPage={20}
          />
          {showModalOrderDetail && (
            <ModalOrderDetail
              orders={selectedOrder}
              showModalOrderDetail={showModalOrderDetail}
              setShowModalOrderDetail={setShowModalOrderDetail}
            />
          )}
        </Card.Body>
      </Card>
    </Fragment>
  )
}

export default Transfer
